import { Reducer } from 'redux';

import { Action, createAction } from '../../../store/actionUtils';

export interface FeaturedShow {
    poster: string;
    title: string;
    url: string;
}

export enum FeaturedShowActionTypes {
    RECEIVE_FEATURED_SHOWS = 'ShowsIndex/featuredShows/RECEIVE_FEATURED_SHOWS',
}

export type ReceiveFeaturedShowsAction = Action<FeaturedShowActionTypes.RECEIVE_FEATURED_SHOWS, FeaturedShow[]>;

const featuredShowsReducer: Reducer<FeaturedShow[], ReceiveFeaturedShowsAction> = (state = [], action) => {
    switch (action.type) {
        case FeaturedShowActionTypes.RECEIVE_FEATURED_SHOWS:
            return action.payload;
        default:
           return state;
    }
};

// Action creators
export const receiveFeaturedShows = createAction<ReceiveFeaturedShowsAction>(
    FeaturedShowActionTypes.RECEIVE_FEATURED_SHOWS,
    doc => (doc.featured_shows as any[]).map<FeaturedShow>(row => ({
        poster: row.featured_show_image,
        title: row.featured_show_caption,
        url: row.featured_show_link,
    })),
);

export default featuredShowsReducer;
